// src/authConfig.js

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin, // keep root landing
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // Renew a bit before expiry (seconds). This is MSAL's internal early-renew window.
    tokenRenewalOffsetSeconds: 300, // 5 minutes
  },
};

// Login = identity only (OIDC). Keep it small & stable.
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// Graph token request (used after login for groups/user info)
export const graphRequest = {
  scopes: ["User.Read", "GroupMember.Read.All"],
};
